import React from 'react';

interface LoadingProps {
  message?: string;
  className?: string;
}

export const InlineLoading = ({ message = 'Loading...', className = '' }: LoadingProps) => {
  const containerStyles: React.CSSProperties = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '1rem'
  };

  const textStyles: React.CSSProperties = {
    color: '#7e8299',
    fontWeight: 500
  };

  return (
    <div style={containerStyles} className={className}>
      <span style={textStyles}>{message}</span>
    </div>
  );
};
